export type ReviewGateDecision = {
  reviewCount: number;
  isGated: boolean;
};

export const decideReviewGate = (reviewCount: number, requiredCount: number): ReviewGateDecision => ({
  reviewCount,
  isGated: reviewCount < requiredCount,
});
